import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import MonitorDetailPage from './pages/MonitorDetailPage';
import IncidentsPage from './pages/HistoryPage';
import LoginPage from './pages/LoginPage';
import AdminMonitorsPage from './pages/admin/AdminMonitorsPage';
import AdminGroupsPage from './pages/admin/AdminGroupsPage';
import AdminRecipientsPage from './pages/admin/AdminRecipientsPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminAuditPage from './pages/admin/AdminAuditPage';

const rawBasePath = (process.env.REACT_APP_BASE_PATH || '').trim();
const cleanBasePath = rawBasePath.replace(/^\/+|\/+$/g, '');
const normalizedBasePath = cleanBasePath
  ? `/${cleanBasePath}`
  : undefined;

const App: React.FC = () => (
  <Router basename={normalizedBasePath}>
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/monitor/:id" element={<MonitorDetailPage />} />
      <Route path="/incidents" element={<IncidentsPage />} />
      <Route path="/history" element={<Navigate to="/incidents" replace />} />
      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/admin" element={<Navigate to="/admin/monitors" replace />} />
      <Route path="/admin/monitors" element={<AdminMonitorsPage />} />
      <Route path="/admin/groups" element={<AdminGroupsPage />} />
      <Route path="/admin/recipients" element={<AdminRecipientsPage />} />
      <Route path="/admin/users" element={<AdminUsersPage />} />
      <Route path="/admin/audit" element={<AdminAuditPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
);

export default App;
